import { useState } from "react";
import api from "@/lib/api";
import { extractApiError } from "@/components/PanelState";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarCheck2 } from "lucide-react";

// ============================================================================
// SendStaffMeetingInviteButton — Phase G executor action (pt.35).
// Visible to the current owner (typically Juliana) after the
// staff_meeting_invite approval exists. Fires the shadow-event
// helper server-side; Preview skips (flag off) but records the
// attempt on the timeline. Idempotent — a second click returns
// the existing invite verbatim.
// ============================================================================

export default function SendStaffMeetingInviteButton({ candidate, onSent }) {
  const [sending, setSending] = useState(false);
  const alreadySent = !!candidate?.staff_meeting_invite?.google_event_id;

  async function send() {
    if (!window.confirm(
      "Send the Monday staff-meeting Google Calendar invite to this candidate?"
    )) return;
    setSending(true);
    try {
      const { data } = await api.post(
        `/hiring/candidates/${candidate.id}/send-staff-meeting-invite`,
        {},
      );
      if (data.skipped) {
        toast(
          "Send skipped — Google Calendar disabled or misconfigured on this "
          + "environment. Check backend logs for the WARN."
        );
      } else {
        toast.success(
          "Staff meeting invite sent for "
          + new Date(data.staff_meeting_invite.scheduled_at).toLocaleDateString(),
        );
      }
      onSent?.(data);
    } catch (e) {
      toast.error(extractApiError(e) || "Send failed");
    } finally {
      setSending(false);
    }
  }

  if (alreadySent) return null; // Nothing to do — chip on the offer card will show it.

  return (
    <Button
      size="sm"
      onClick={send}
      disabled={sending}
      data-testid="hiring-candidate-send-staff-meeting-invite-btn"
    >
      <CalendarCheck2 className="w-4 h-4 mr-1.5" />
      {sending ? "Sending…" : "Send staff meeting invite"}
    </Button>
  );
}
